
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.479 33.727V20.76h-4.306v12.966h4.306zM16.327 18.99c1.5 0 2.435-.995 2.435-2.24-.028-1.272-.934-2.24-2.407-2.24-1.474 0-2.436.968-2.436 2.24 0 1.245.934 2.24 2.38 2.24h.027zm4.535 14.737h4.306v-7.24c0-.388.028-.776.141-1.052.311-.775 1.02-1.576 2.21-1.576 1.558 0 2.181 1.188 2.181 2.932v6.936h4.305v-7.435c0-3.982-2.124-5.836-4.956-5.836-2.323 0-3.343 1.3-3.91 2.185h.029v-1.88h-4.306c.056 1.216 0 12.966 0 12.966z","fill":"#1D1D1D"}})])
          )
        }
      }
    